<template id="cmsForm">
    <div>
        <h3 v-if="formErrors.isInitSEOData" class="text-danger">
            {{ formErrors.initSEODataError }}
        </h3>
        <div v-if="!formErrors.isInitSEOData">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">Home</a></li>
                    <li class="breadcrumb-item">
                        <a href="/product">product</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        edit form
                    </li>
                </ol>
            </nav>
            <div class="row mt-3">
                <div class="col-md-10">
                    <h3>
                        Edit Product SEO Code
                        {{
                            product &&
                            product[0] &&
                            product[0].code !== undefined
                                ? product[0].code
                                : ""
                        }}
                    </h3>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <ul class="nav nav-tabs">
                        <li
                            class="nav-item"
                            v-for="(language, index) in languages"
                            :key="index"
                        >
                            <a
                                class="nav-link"
                                :class="{ active: language.active }"
                                @click="switchLanguage(index)"
                                >{{ language.label }}</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content mt-3">
                <div
                    class="tab-pane"
                    v-for="(language, index) in form.languages"
                    :key="index"
                    :class="{ active: languages[index].active }"
                >
                    <div class="form-group">
                        <label for="product_name">Product Name *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.product_name"
                            :ref="`product_name_${index}`"
                        />
                        <div
                            v-if="formErrors.product_name[index]"
                            class="text-danger"
                        >
                            {{ formErrors.product_name[index] }}
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="product_description"
                            >Product Description *</label
                        >
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="language.product_description"
                            row="6"
                            :ref="`product_description_${index}`"
                        ></textarea>
                        <div
                            v-if="formErrors.product_description[index]"
                            class="text-danger"
                        >
                            {{ formErrors.product_description[index] }}
                        </div>
                    </div>
                    <!-- if language.language == 'eng' display remark textarea  -->
                    <div class="form-group" v-if="index === 1">
                        <label for="remark">Remark *</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="language.remark"
                            row="6"
                        ></textarea>
                    </div>

                    <div class="form-group">
                        <label for="title">Title</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.title"
                        />
                    </div>
                    <div class="form-group">
                        <label for="meta_description">Meta Description</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="language.meta_description"
                            rows="6"
                        ></textarea>
                    </div>
                    <!-- <div class="form-group">
                        <label for="title">H1</label>
                        <input type="text" class="form-control" v-model="language.h1" />
                    </div> -->
                    <div class="form-group">
                        <label for="canonical_tag">Canonical</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.canonical_tag"
                        />
                    </div>
                    <div class="form-group">
                        <label for="link_rel_alternate_hreflang"
                            >Link Rel Alternate Hreflang</label
                        >
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.link_rel_alternate_hreflang"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_sitename">OG Sitename</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.og_sitename"
                        />
                    </div>
                    <div class="form-group">
                        <label for="twitter_site">Twitter Site</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.twitter_site"
                        />
                    </div>
                    <div class="form-group">
                        <label for="twitter_domain">Twitter Domain</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.twitter_domain"
                        />
                    </div>
                    <div class="form-group">
                        <label for="structured_data">Structured Data</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="language.structured_data"
                            rows="6"
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="og_title">OG Title</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.og_title"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_description">OG Description</label>
                        <textarea
                            type="text"
                            class="form-control"
                            v-model="language.og_description"
                            rows="6"
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <label for="og_image">OG Image</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.og_image"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_image_height"
                            >OG Image Height (optional)</label
                        >
                        <input
                            type="number"
                            class="form-control"
                            v-model="language.og_image_height"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_image_width"
                            >OG Image Width (optional)</label
                        >
                        <input
                            type="number"
                            class="form-control"
                            v-model="language.og_image_width"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_image_type">OG Image Type</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.og_image_type"
                        />
                    </div>
                    <div class="form-group">
                        <label for="og_url">OG URL</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.og_url"
                        />
                    </div>
                    <div class="form-group">
                        <label for="twitter_card">Twitter Card</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.twitter_card"
                        />
                    </div>
                    <div class="form-group">
                        <label for="twitter_creator">Twitter Creator</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.twitter_creator"
                        />
                    </div>
                    <div class="form-group">
                        <label for="twitter_title">Twitter Title</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="language.twitter_title"
                        />
                    </div>
                    <div class="form-group">
                        <label for="status">Status</label>
                        <select
                            class="form-control col-md-3"
                            id="status"
                            v-model="language.status"
                        >
                            <option value="0" :selected="language.status == 0">
                                Draft
                            </option>
                            <option value="1" :selected="language.status == 1">
                                Publish
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <hr />
            </div>
            <div class="row">
                <div
                    class="col-md-12"
                    style="display: flex; justify-content: center"
                >
                    <div class="form-group float-right">
                        <a href="/product" class="btn btn-secondary">ยกเลิก</a>
                        <button
                            type="button"
                            class="btn btn-primary ml-5"
                            @click="validateForm"
                        >
                            บันทึก
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item_id: "",
        store_id: "",
    },
    data() {
        return {
            base_url: "/product",
            product: {},
            product_info: {},
            form: {
                code: "",
                languages: [
                    {
                        status: 0,
                        product_name: "",
                        product_description: "",
                        remark: "",
                        link_rel_alternate_hreflang: "",
                        og_sitename: "",
                        twitter_site: "",
                        twitter_domain: "",
                        structured_data: "",
                        title: "",
                        meta_description: "",
                        h1: "",
                        canonical_tag: "",
                        og_title: "",
                        og_description: "",
                        og_image: "",
                        og_image_height: null,
                        og_image_width: null,
                        og_image_type: "",
                        og_url: "",
                        twitter_card: "",
                        twitter_creator: "",
                        twitter_title: "",
                    },
                ],
            },
            languages: [{ label: "TH", active: true }],
            formErrors: {
                product_name: [],
                product_description: [],
                isInitSEOData: false,
                initSEODataError: "",
            },
        };
    },
    mounted() {
        this.load(this.item_id);
    },
    methods: {
        load(id) {
            //let getURL = this.base_url + '/show-product-seo/'+ id;
            axios
                .get(this.base_url + "/show-product-seo/" + id)
                .then((response) => {
                    this.product = response.data.product_seo;
                    this.product_info = response.data.product_info;
                    this.initFields();
                })
                .catch((errors) => {
                    this.formErrors.isInitSEOData = true;
                    this.formErrors.initSEODataError =
                        'หากต้องการแก้ไขข้อมูลของสินค้านี้ กรุณากดปุ่ม"สร้างข้อมูล SEO สำหรับสินค้าใหม่" ในหน้ารวมสินค้า';
                    this.product.code = undefined;
                    console.log("Error:", errors);
                });
        },
        initFields() {
            let products = this.product;
            let product_info = this.product_info;
            products.forEach((item, idx) => {
                let lang = "tha";
                let seo_url =
                    "/พวงหรีด/" +
                    product_info[lang].code +
                    "-" +
                    product_info[lang].name.replace(/\s+/g, "-") +
                    "/";
                if (idx === 1) {
                    lang = "eng";
                    seo_url =
                        "/en/พวงหรีด/" +
                        product_info[lang].code +
                        "-" +
                        product_info[lang].name.replace(/\s+/g, "-") +
                        "/";
                }
                let image_url = product_info[lang].imgs;
                // let product_name = product_info[lang].name;
                let product_name = item.product_name;
                let product_description = product_info[lang].brief;
                let product_remark = product_info[lang].detail
                    ? product_info[lang].detail
                    : null;
                this.form.code = product_info[lang].code
                    ? product_info[lang].code
                    : "";
                this.form.languages[idx].status = item.status === 0 ? 0 : 1;
                this.form.languages[idx].product_name = product_name;
                this.form.languages[idx].product_description =
                    product_description;
                this.form.languages[idx].remark = product_remark
                    ? product_remark
                    : "";
                this.form.languages[idx].link_rel_alternate_hreflang =
                    item.link_rel_alternate_hreflang
                        ? item.link_rel_alternate_hreflang
                        : seo_url;
                this.form.languages[idx].og_sitename = item.og_sitename
                    ? item.og_sitename
                    : "wreathmala.com";
                this.form.languages[idx].twitter_site = item.twitter_site
                    ? item.twitter_site
                    : "@wreathmala";
                this.form.languages[idx].twitter_domain = item.twitter_domain
                    ? item.twitter_domain
                    : "wreathmala.com";
                this.form.languages[idx].structured_data = item.structured_data
                    ? item.structured_data
                    : null;
                this.form.languages[idx].title = item.title
                    ? item.title
                    : product_info[lang].name;
                this.form.languages[idx].h1 = item.h1 ? item.h1 : item.title;
                this.form.languages[idx].meta_description =
                    item.meta_description
                        ? item.meta_description
                        : product_info[lang].description;
                this.form.languages[idx].canonical_tag = item.canonical_tag
                    ? item.canonical_tag
                    : seo_url;
                this.form.languages[idx].og_title = item.og_title
                    ? item.og_title
                    : item.title;
                this.form.languages[idx].og_description = item.og_description
                    ? item.og_description
                    : item.meta_description;
                this.form.languages[idx].og_image = item.og_image
                    ? item.og_image
                    : image_url;
                this.form.languages[idx].og_image_height = item.og_image_height
                    ? item.og_image_height
                    : 630;
                this.form.languages[idx].og_image_width = item.og_image_width
                    ? item.og_image_width
                    : 1200;
                this.form.languages[idx].og_image_type = item.og_image_type
                    ? item.og_image_type
                    : "image/webp";
                this.form.languages[idx].og_url = item.og_url
                    ? item.og_url
                    : seo_url;
                this.form.languages[idx].twitter_card = item.twitter_card
                    ? item.twitter_card
                    : "summary";
                this.form.languages[idx].twitter_creator = item.twitter_creator
                    ? item.twitter_creator
                    : "@wreathmala";
                this.form.languages[idx].twitter_title = item.twitter_title
                    ? item.twitter_title
                    : item.title;
                this.form.languages[idx].language = item.language
                    ? item.language
                    : lang;
            });
        },
        switchLanguage(index) {
            this.languages.forEach((language, idx) => {
                language.active = idx === index;
            });
        },
        saveWithGoBack() {
            this.save().then(() => {
                history.back();
            });
        },
        save() {
            let save_url = this.item_id
                ? `${this.base_url}/update/${this.item_id}`
                : this.base_url;
            console.log("form:", this.form);

            axios
                .post(save_url, this.form)
                .then((response) => {
                    console.log(response);
                    history.back();
                })
                .catch((errors) => {
                    console.log(errors.response.data);
                });
        },
        validateForm() {
            // Clear previous errors
            this.formErrors.product_name = [];
            this.formErrors.product_description = [];

            // Perform validation
            let isValid = true;

            this.form.languages.forEach((language, index) => {
                if (!language.product_name) {
                    this.formErrors.product_name[index] =
                        "Product Name is required.";
                    isValid = false;
                    this.$refs[`product_name_${index}`][0].focus();
                    return;
                }
                if (!language.product_description) {
                    this.formErrors.product_description[index] =
                        "Product Description is required.";
                    isValid = false;
                    this.$refs[`product_description_${index}`][0].focus();
                    return;
                }
            });

            // If valid, proceed to save
            if (isValid) {
                this.saveWithGoBack();
            } else {
                console.log("Validation failed:", this.formErrors);
            }
        },
    },
};
</script>
